<div class="registration-container">
  @if (!processingRegistration) {
    <mat-card>
      <mat-card-content>
        <h1 class="header-align">
          {{ 'scheduler.registration.welcome.title' | translate }} {{ tokenName }}
        </h1>
        <p class="header-align">
          {{ 'scheduler.registration.welcome.message' | translate }}
        </p>
        <mat-horizontal-stepper #stepper linear>
          <mat-step [stepControl]="firstFormGroup" label="Display Name">
            <ng-template matStepLabel>
              {{ 'scheduler.registration.welcome.step1' | translate }}
            </ng-template>
            <form [formGroup]="firstFormGroup" class="form-container">
              <mat-form-field>
                <input formControlName="displayName" matInput placeholder="Display Name" required>
              </mat-form-field>
              <div class="button-row">
                <span class="spacer"></span>
                <button color="primary" mat-flat-button matStepperNext>{{ 'scheduler.general.next' | translate }}</button>
              </div>
            </form>
          </mat-step>
          <mat-step [stepControl]="secondFormGroup" label="Select Teams">
            <ng-template matStepLabel>
              {{ 'scheduler.registration.welcome.step2' | translate }}
            </ng-template>
            <div class="form-container">
              <form [formGroup]="secondFormGroup">
                @if (stepper.selectedIndex > 0) {
                  <app-grid #grid [autoHeight]=true [cellEdit]="false" [columns]="columns"
                  [data]="rows" [rowHeight]="50" [selectionMode]="selectionMode"></app-grid>
                }
                <div class="button-row">
                  <button mat-button matStepperPrevious>{{ 'scheduler.general.back' | translate }}</button>
                  <span class="spacer"></span>
                  <button color="primary" mat-flat-button matStepperNext>{{ 'scheduler.general.next' | translate
                  }}</button>
                </div>
              </form>
            </div>
          </mat-step>
          <mat-step [stepControl]="thirdFormGroup" label="Complete">
            <ng-template matStepLabel>
              {{ 'scheduler.registration.welcome.step3' | translate }}
            </ng-template>
            <form [formGroup]="thirdFormGroup" class="form-container">
              <p>
                {{ 'scheduler.registration.confirm.name' | translate }} {{ firstFormGroup.controls['displayName'].value
                }}.
              </p>
              <p>
                {{ 'scheduler.registration.confirm.team-list' | translate }}
              </p>
              @if (this.grid) {
                <ul class="team-list">
                  @for (record of this.grid.selectedRecords; track record) {
                    <li>
                      {{ record.get('team') }}
                    </li>
                  }
                </ul>
              }
              {{ 'scheduler.registration.confirm' | translate }}
              <div class="button-row">
                <button mat-button matStepperPrevious>{{ 'scheduler.general.back' | translate }}</button>
                <span class="spacer"></span>
                <button (click)="finaliseRegistration()" color="primary" mat-flat-button matStepperNext>
                  {{ 'scheduler.general.finish' | translate }}
                </button>
              </div>
            </form>
          </mat-step>
        </mat-horizontal-stepper>
      </mat-card-content>
    </mat-card>
  }

  @if (processingRegistration && !registrationComplete) {
    <mat-card class="registration-container">
      <h1 class="header-align">{{ 'scheduler.registration.inProgress' | translate }}</h1>
      <div class="spinner-container">
        <mat-progress-spinner [diameter]="150" mode="indeterminate"></mat-progress-spinner>
      </div>
      <p class="header-align">
        {{ 'scheduler.registration.pleaseWait' | translate }}
      </p>
    </mat-card>
  }

  @if (processingRegistration && registrationComplete && !registrationError) {
    <mat-card>
      <h1 class="header-align">{{ 'scheduler.registration.complete' | translate }}</h1>
      <p class="header-align">{{ 'scheduler.registration.complete.subtext' | translate }}</p>
      <div class="header-align" style="margin-bottom: 24px;">
        <button (click)="reloadWindow()" color="primary" mat-flat-button>Start work</button>
      </div>
    </mat-card>
  }

  @if (processingRegistration && registrationComplete && registrationError) {
    <mat-card class="registration-container">
      <h1 class="header-align">{{ 'scheduler.registration.error' | translate }}</h1>
      <p class="header-align">{{ 'scheduler.registration.error.subtext' | translate }} {{ errorTime }}</p>
      <p class="header-align">{{ errorMessage }}</p>
    </mat-card>
  }
</div>
